import { createFileRoute } from '@tanstack/react-router'
import WorkLaunchBriefGridSearch from 'Work/components/Work/search/WorkLaunchBriefGridSearch'

export const Route = createFileRoute('/_worksearch/work/launchbrief')({
    validateSearch: (search: Record<string, string>) => search,
    component: WorkLaunchBriefGridSearch,
})
